import React, { useState } from 'react';
import { X } from 'lucide-react';
import { STORE_CONFIG } from '../../config/storeConfig';
import { trackClickButton } from '../../lib/analytics';

export const WhatsAppButton: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(true);

  const handleClickWhatsApp = () => {
    trackClickButton('WhatsApp_Floating_Chat', {
      channel: 'WhatsApp',
      number: STORE_CONFIG.whatsappNumber,
    });
  };

  return (
    <div
      id="whatsapp-floating-container"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2.5 animate-bounce-subtle"
    >
      {/* Speech Bubble / Badge */}
      {showTooltip && (
        <div className="relative bg-white text-[#172554] px-3.5 py-1.5 rounded-full shadow-lg border border-slate-200 text-xs font-bold flex items-center gap-1.5 group cursor-pointer">
          <a
            href={STORE_CONFIG.getWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClickWhatsApp}
            className="hover:text-emerald-600 transition-colors flex items-center gap-1.5"
          >
            <span>Need Help? Chat on WhatsApp</span>
          </a>
          <button
            onClick={() => setShowTooltip(false)}
            className="text-slate-400 hover:text-slate-600 p-0.5 rounded-full"
            aria-label="Dismiss chat bubble"
          >
            <X className="w-3 h-3" />
          </button>
          {/* Arrow pointing to icon */}
          <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[5px] border-t-transparent border-b-[5px] border-b-transparent border-l-[6px] border-l-white" />
        </div>
      )}

      {/* Official WhatsApp Floating Button */}
      <a
        id="whatsapp-floating-btn"
        href={STORE_CONFIG.getWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClickWhatsApp}
        className="w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-108 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-emerald-300 group"
        title="Chat with Health Store on WhatsApp"
        aria-label="Open WhatsApp live chat"
      >
        {/* Official WhatsApp Logo Vector */}
        <svg
          className="w-8 h-8 fill-white transition-transform group-hover:scale-110"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </a>
    </div>
  );
};

